"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampDateSchema = exports.timestampIsoSchema = void 0;
const primitives_1 = require("../../primitives");
/**
 * Canonical API timestamp schema (ISO-8601 string)
 */
exports.timestampIsoSchema = primitives_1.timestampIsoPrimitiveSchema;
/**
 * Canonical database timestamp schema
 */
exports.timestampDateSchema = primitives_1.timestampDatePrimitiveSchema;
